export const SURVEY_RESPONSES_KEY = 'trial-guide-survey-responses';